import React from 'react';
import classNames from 'classnames';
import { Button } from '@fiverr-private/fit';
import { VARIANTS } from '../../../types/variants';

export const TRANSLATION_KEY = 'gig_page_perseus.mobile_sticky_cta.contact_seller';

export const CHAT_BUTTON_VARIANTS = {
    [VARIANTS.B]: {
        className: 'contact-seller-btn',
        color: Button.COLORS.WHITE,
        textColor: Button.TEXT_COLORS.DARK_GREY
    },
    [VARIANTS.C]: {
        className: classNames('contact-seller-btn', 'box-shadow-z4'),
        color: Button.COLORS.WHITE,
        textColor: Button.TEXT_COLORS.DARK_GREY
    }
};

export const AVATAR_VARIANTS = {
    [VARIANTS.B]: {
        size: 24
    },
    [VARIANTS.C]: {
        size: 32
    }
};
